import { Component, lazy, Suspense } from 'react';
import LoaderComponent from '@components/atom/layout/loader';
import SearchBox from '@components/template/keyword/translator/searchBox';
import ResultBox from '@components/template/keyword/translator/resultBox';

const AppInfo = lazy(() => import('@components/template/layout/appInfo/appInfo'));

const Localization = () => {
  return (
    <>
      <div className="app-info">
        <Suspense fallback={<LoaderComponent />}>
          <AppInfo />
        </Suspense>
      </div>
      <SearchBox />
      <ResultBox />
    </>
  );
};

export default Localization;
